import $ from 'jquery'
import Masonry from 'masonry-layout'
import { trackEvent } from './analytics'

const LOAD_BTN = 'data-frontpage-related-items-load'

function setupElement(el) {
  const masonryEl = $('.mgrid', el)
  const masonry = new Masonry(masonryEl.get(0), {
    itemSelector: '.mgrid__item',
    columnWidth: '.mgrid__sizer',
    percentPosition: true
  })

  $(el)
    .imagesLoaded()
    .progress(function() {
      masonry.layout()
    })

  let config = JSON.parse(document.getElementById('related-items').textContent)
  let filter = ''

  const loadBtn = $(`[${LOAD_BTN}]`, el)
  const url = loadBtn.attr(LOAD_BTN)

  const filterMasonry = (filter) => {
    trackEvent('masonry', 'filter', filter)
    if (filter === '') {
      $('.mgrid__item', el).removeClass('d-none')
    } else {
      $('.mgrid__item', el).addClass('d-none')
      $(`.mgrid__item--${filter}`, el).removeClass('d-none')
    }
    loadBtn.toggleClass('disabled', !config[`${filter}has_more`])
    masonry.layout()
  }

  $('[data-masonry-filter]').click(function() {
    filter = $(this).attr('data-masonry-filter')
    $('[data-masonry-filter]').removeClass('active')
    $(this).addClass('active')
    filterMasonry(filter)
  })

  $('#frontpage-related-filter').change(function() {
    const val = $(this).val()
    if (val[0] === '/') {
      window.location = val
      return
    }
    filter = val
    filterMasonry(filter)
  })

  const loadMore = () => {
    loadBtn.addClass('disabled')
    trackEvent('masonry', 'load', filter)
    $.post(`${url}?typ=${filter}`, { config: JSON.stringify(config) }).then(
      data => {
        const $items = $(data.html)
        config = {
          ...config,
          ...data.config,
          exclude: [...config.exclude, ...data.config.exclude]
        }
        $(masonryEl).append($items)
        masonry.appended($items)
        loadBtn.toggleClass('disabled', !config[`${filter}has_more`])
        $items.imagesLoaded().progress(function() {
          masonry.layout()
        })
      }
    )
  }

  //loadMore()

  loadBtn.click(function(evt) {
    evt.preventDefault()
    loadMore()
  })
}

$.fn.frontpageRelatedItems = function() {
  return this.each(function() {
    setupElement(this)
  })
}
